import React from 'react';
import PropTypes from 'prop-types';
import { get, has, orderBy } from 'lodash';
import moment from 'moment';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl, InfiniteScroll } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBannerAlt from '../../components/PageIntroBannerAlt';
import MenuAbout from '../../components/MenuAbout';

class Latest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 3,
      increment: 3,
    };

    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    this.setState({
      limit: this.state.limit + this.state.increment,
    });
  }

  render() {
    const { page, blogposts } = this.props;
    const { limit } = this.state;
    if (!page) {
      return null;
    }

    return (
      <div>
        <InsideHeader h1="Latest News" background={get(page, 'page_image.contentUrl')} />
        <PageHelmet page={page} />
        <Header />
        <MenuAbout />
        <div className="container">
          <div className="row">
            <div className="col">
              <PageIntroBannerAlt
                h2={get(page, 'intro_banner[0].main_headline')}
                p={get(page, 'intro_banner[0].paragraph')}
                background={get(page, 'intro_banner[0].photo.contentUrl')}
              />
            </div>
          </div>
          {
            orderBy(blogposts, ['date'], ['desc']).slice(0, limit).map(blogpost => (
              <div className="row blogposts" key={blogpost._id}>
                <div className="col-lg-4 py-5 justify-content-center align-items-center d-flex">
                  <div className="result-media" style={{ backgroundImage: `url(${buildThumbnailUrl(get(blogpost, 'logo.contentUrl'), { width: 800, height: 800 })})` }} />
                </div>
                <div className="col-lg-8 p-0">
                  <div className="result-content">
                    <div className="row">
                      <div className="col-md-8 mx-auto">
                        <Link
                          name="latest-news"
                          params={{
                            blogpostTitle: blogpost.title,
                          }}
                        >
                          <h3 className="underdog-left">{blogpost.title}</h3>
                          <h4>
                            {
                              has(blogpost, 'date') &&
                              moment(get(blogpost, 'date')).format('MMMM D, YYYY')
                            }
                          </h4>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
          {
            limit < blogposts.length &&
            <div style={{ textAlign: 'center' }}>
              <InfiniteScroll
                action={this.showMore}
                message="Load More"
                messageAfter={2}
                finished={limit >= blogposts.length}
              />
            </div>
          }
        </div>
        <Footer />
      </div>
    );
  }
}

Latest.propTypes = {
  page: PropTypes.object,
  blogposts: PropTypes.arrayOf(PropTypes.object),
};

Latest.defaultProps = {
  page: undefined,
  blogposts: [],
};

export default withData({
  page: 'latest_news',
  blogposts: true,
})(Latest);



// WEBPACK FOOTER //
// ./src/pages/LatestNews/index.js